export default __webpack_public_path__ + "images/0x3c1bca5a656e69edcd0d4e36bebb3fcdaca60cf1.png";